"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var exportTableToExcel_1 = require("portal/components/Grid/helpers/exportTableToExcel");
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var use_react_router_1 = __importDefault(require("use-react-router"));
var useTitle_1 = __importDefault(require("../../../hooks/useTitle"));
var permissiontypes_1 = require("../Users/permissiontypes");
function SupplierAdd() {
    var _this = this;
    var _a;
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useTitle_1.default)(t("common.suppliersList"));
    var _b = (0, react_1.useState)(""), search = _b[0], setSearch = _b[1];
    var snapshot = (0, firestore_1.useCollection)(collectionsRef_1.suppliersRef
        .where("nameIndex", "array-contains", search.toLowerCase().trim())
        .limit(9))[0];
    var history = (0, use_react_router_1.default)().history;
    var dataSource = ((_a = snapshot === null || snapshot === void 0 ? void 0 : snapshot.docs) !== null && _a !== void 0 ? _a : []).map(function (s) {
        return __assign(__assign({}, s.data()), { id: s.id });
    });
    var columns = [
        {
            name: "businessType",
            title: t("suppliers.businessType"),
        },
        {
            name: "companyName",
            title: t("suppliers.companyName"),
        },
        { name: "contactPerson", title: t("suppliers.contactPerson") },
        { name: "mobilePhone", title: t("suppliers.mobilePhone") },
        { name: "email", title: t("suppliers.email") },
        { name: "city", title: t("suppliers.city") },
        { name: "country", title: t("suppliers.country") },
        {
            name: "id",
            title: t("common.actions"),
            key: "id",
            filteringEnabled: false,
            getCellValue: function Actions(row) {
                return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, permissiontypes_1.permissionTypes)("viewSupplier") ? ((0, jsx_runtime_1.jsx)("span", __assign({ style: {} }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/suppliers/".concat(row.id), type: "primary", style: { margin: "0px 5px" } }, { children: t("common.view") })) }))) : null, (0, permissiontypes_1.permissionTypes)("editSupplier") ? ((0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/suppliers/".concat(row.id, "/edit"), type: "primary", style: { margin: "0px 5px" } }, { children: t("common.edit") })) })) : null] }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ style: { padding: 16, paddingBottom: 0 }, label: t("suppliers.searchForSupplierName") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { onChange: function (e) { return setSearch(e.target.value); }, value: search }) })), (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: dataSource, columns: columns }, { children: __spreadArray(__spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({
                    table: "suppliers",
                    groups: false,
                    filter: false,
                }), true), [(0, permissiontypes_1.permissionTypes)("createSupplier") ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: {
                            position: "absolute",
                            right: "90px",
                            marginTop: 16,
                            zIndex: 999,
                        }, onClick: function () {
                            navigate("/suppliers/new");
                        } }, { children: t("suppliers.addNewSupplier") }))) : null, (0, permissiontypes_1.permissionTypes)("exportSuppliers") ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: {
                            position: "absolute",
                            right: "250px",
                            marginTop: 16,
                            zIndex: 999,
                        }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            var fileName, fields, titles;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        fileName = "Suppliers Table";
                                        fields = [
                                            "companyName",
                                            "companyNumber",
                                            "contactPerson",
                                            "businessType",
                                            "country",
                                            "city",
                                            "email",
                                            "physicalAddress",
                                            "website",
                                            "bankInformation",
                                            "mobilePhone",
                                        ];
                                        titles = [
                                            t("suppliers.companyName"),
                                            t("suppliers.companyNumber"),
                                            t("suppliers.contactPerson"),
                                            t("suppliers.businessType"),
                                            t("suppliers.country"),
                                            t("suppliers.city"),
                                            t("suppliers.email"),
                                            t("suppliers.physicalAddress"),
                                            t("suppliers.website"),
                                            t("suppliers.bankInformation"),
                                            t("suppliers.mobilePhone"),
                                        ];
                                        return [4 /*yield*/, (0, exportTableToExcel_1.exportTablesToExcel)(collectionsRef_1.suppliersRef, fields, titles, fileName)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); } }, { children: t("common.exportToExcel") }))) : null], false) }))] }));
}
exports.default = SupplierAdd;
